import type { MemberAccessRule } from './types.js';

export const C_MEMBER_ACCESS_RULES: MemberAccessRule[] = [
  { parentType: 'field_expression', objectField: 'argument', propertyField: 'field', tagKind: 'member' },
];
